import { render, staticRenderFns } from "./EditApprovalChainTemplateDialog.vue?vue&type=template&id=3333a30c&"
import script from "./EditApprovalChainTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./EditApprovalChainTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports